"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importStar(require("../../../theme/styled-components"));
var _1 = require(".");
var icons_1 = tslib_1.__importDefault(require("./icons"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n"], ["\n  font-size: ", ";\n"])), polished_1.rem(14));
var IconWrapper = styled_components_1["default"].span(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin-right: ", ";\n  display: inline-block;\n  vertical-align: middle;\n"], ["\n  margin-right: ", ";\n  display: inline-block;\n  vertical-align: middle;\n"])), polished_1.rem(8));
var Comments = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var Comment = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  padding: ", " 0;\n  border-bottom: 1px dotted #ececec;\n  display: flex;\n  ", "\n"], ["\n  padding: ", " 0;\n  border-bottom: 1px dotted #ececec;\n  display: flex;\n  ",
    "\n"])), polished_1.rem(8), function (_a) {
    var important = _a.important;
    return important && styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      font-weight: bold;\n    "], ["\n      font-weight: bold;\n    "])));
});
var CommentTime = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  padding-right: ", ";\n  font-weight: bold;\n  min-width: ", ";\n"], ["\n  padding-right: ", ";\n  font-weight: bold;\n  min-width: ", ";\n"])), polished_1.rem(8), polished_1.rem(60));
var IMPORTANT_LABELS = ['important', 'goal', 'time'];
var C = function (_a) {
    var comments = _a.comments, sport = _a.sport;
    React.useEffect(function () {
        var documents = document.getElementsByClassName('gfyitem');
        Array.from(documents || []).forEach(function (img) {
            fetch("https://api.gfycat.com/v1/gfycats/" + img.getAttribute('data-id'))
                .then(function (res) {
                if (!res.ok || res.status !== 200) {
                    throw new Error();
                }
                return res.json();
            })
                .then(function (data) {
                var _a;
                // create video
                var el = document.createElement('video');
                el.loop = false;
                el.autoplay = false;
                el.muted = false;
                el.controls = true;
                el.setAttribute('style', 'width: 100%; height: auto');
                // mp4
                var mp4Source = document.createElement('source');
                mp4Source.setAttribute('data-src', data.gfyItem.mp4Url);
                mp4Source.setAttribute('src', data.gfyItem.mp4Url);
                mp4Source.setAttribute('type', 'video/mp4');
                el.appendChild(mp4Source);
                // webm
                var webmSource = document.createElement('source');
                webmSource.setAttribute('data-src', data.gfyItem.webmUrl);
                webmSource.setAttribute('src', data.gfyItem.webmUrl);
                webmSource.setAttribute('type', 'video/webm');
                el.appendChild(webmSource);
                // replace img with video
                (_a = img.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(el, img);
            })["catch"](function (e) {
                //
            });
        });
    }, []);
    var renderCommentIcon = function (label, sportType) {
        if (![
            'goal',
            'yellowCard',
            'redCard',
            'redCardAfterYellow',
            'penOut',
            'penCatch',
            'change',
            'important',
        ].includes(label || '')) {
            return null;
        }
        var eventType = label || '';
        if (label === 'penOut' || label === 'penCatch') {
            eventType = 'important';
        }
        if (label === 'redCardAfterYellow') {
            eventType = 'redCard';
        }
        return (React.createElement(IconWrapper, null,
            React.createElement(icons_1["default"], { size: 14, eventType: eventType || '', title: label || '', sport: sportType || '' })));
    };
    var renderComment = function (comment) {
        return (React.createElement(Comment, { important: IMPORTANT_LABELS.includes(comment.label || '') },
            comment.time && React.createElement(CommentTime, null, comment.time),
            comment.message && (React.createElement("div", null,
                renderCommentIcon(comment.label, sport),
                React.createElement("span", { dangerouslySetInnerHTML: { __html: comment.message } })))));
    };
    return (React.createElement(Wrapper, null,
        React.createElement(_1.Header, null, "Prenos"),
        React.createElement(Comments, null, comments.map(renderComment))));
};
exports["default"] = React.memo(C);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
